// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"PasswordEmailSent_iconWrapper__buyTG","resendMessage":"PasswordEmailSent_resendMessage__3_2vr"};